<div class="flex gap-2">
  <app-pan-button color="primary" icon="add_circle" (click)="params.addCallback(params.data)" matTooltip="Add to Cart"></app-pan-button>
</div>
